/* eslint-disable no-bitwise */

export enum ModalButtons {
    None = 0,
    Ok = 1,
    Cancel = 2,
    Yes = 4,
    No = 8,
    Save = 16,
    Import = 32,
    Add = 64
}

export class ModalButtonSet {
    public static SaveImportCancel:  number = ModalButtons.Save | ModalButtons.Import | ModalButtons.Cancel;
    public static SaveCancel:  number = ModalButtons.Save | ModalButtons.Cancel;
    public static AddCancel:  number = ModalButtons.Add | ModalButtons.Cancel;
    public static OkCancel:  number = ModalButtons.Ok | ModalButtons.Cancel;
    public static YesNo: number = ModalButtons.Yes | ModalButtons.No;
    public static Cancel: number = ModalButtons.Cancel;
    public static Ok: number = ModalButtons.Ok;
    public static None: number = ModalButtons.None;
}
